import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { Section } from '../../../Section';
import { ArticleCard } from '../../ArticleCard';
import { MainColumn, Three, MainContents } from '../partials';
var CTopicSection = function CTopicSection(_ref) {
  var tag = _ref.tag,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin,
    _ref$articlesIsClient = _ref.articlesIsClient,
    articlesIsClient = _ref$articlesIsClient === void 0 ? false : _ref$articlesIsClient;
  var articles = tag.articles;
  var articlesWithImage = articles.filter(function (_ref2) {
    var image = _ref2.image;
    return Boolean(image);
  });
  var featuredArticle = articlesWithImage.slice(0, 3);
  var otherArticle = articles.filter(function (item) {
    return !featuredArticle.map(function (_ref3) {
      var id = _ref3.id;
      return id;
    }).includes(item.id);
  }).slice(0, 6);
  var title = "Contenidos sobre ".concat(tag.tag.name);
  return React.createElement(Section, {
    bottomMargin: bottomMargin,
    title: title
  }, React.createElement(MainContents, null, React.createElement(MainColumn, null, React.createElement(Three, null, featuredArticle.map(function (article, index) {
    return React.createElement(ArticleCard, {
      key: index,
      variant: "medium",
      article: article,
      withImage: true,
      withDate: false,
      isClient: articlesIsClient
    });
  })))), React.createElement(MainColumn, null, React.createElement(Three, null, otherArticle.map(function (article, index) {
    return React.createElement(ArticleCard, {
      key: index,
      variant: "small",
      article: article,
      withImage: false,
      withDate: false,
      withDescription: true,
      isClient: articlesIsClient
    });
  }))));
};
export default CTopicSection;